import { ComponentProps } from 'react';
import { FormattedNumber } from 'react-intl';
import styled from 'styled-components';

import { So5FixtureEvent } from '__generated__/globalTypes';
import { Vertical } from 'atoms/layout/flex';
import { LabelS } from 'atoms/typography';
import { Cost } from 'components/player/Cost';
import { laptopAndAbove } from 'style/mediaQuery';

const AUTHORIZED_SO5_FIXTURE_EVENTS: So5FixtureEvent[] = [
  So5FixtureEvent.DAILY,
  So5FixtureEvent.CLASSIC,
];
const StyledLabelS = styled(LabelS)`
  @media ${laptopAndAbove} {
    font: var(--t-label-m);
    font-weight: bold;
  }
`;
type Props = {
  size: ComponentProps<typeof Cost>['size'];
  projectedScore: number;
  so5FixtureEvent: So5FixtureEvent;
};

export const ProjectionScore = ({
  size,
  projectedScore,
  so5FixtureEvent,
}: Props) => {
  if (!AUTHORIZED_SO5_FIXTURE_EVENTS.includes(so5FixtureEvent)) return null;
  return (
    <Cost
      size={size}
      color="var(--c-rotowire)"
      score={
        <Vertical gap={0} center>
          <StyledLabelS bold color="var(--c-white)">
            <FormattedNumber value={projectedScore} maximumFractionDigits={0} />
          </StyledLabelS>
        </Vertical>
      }
      inverted={so5FixtureEvent === So5FixtureEvent.DAILY}
    />
  );
};
